import React from "react";
import PropTypes from "prop-types";
import { Box, Stack, Typography, DateTimeStandard } from "@curves/ui-base";
import { TimeLine } from "@curves/ui-shared";
import { ActivityRecordCard } from "@shared/components";
import { parseDate } from "@util/moment";

// 功能：出貨單紀錄時間軸（對應 ClubStockOutRecordResponseModel）
const ShipmentRecordList = ({ records = [], className = "" }) => {
	const list = records || [];

	if (!list.length) return null;

	return (
		<TimeLine as="ul" className={`membership-record ${className}`.trim()}>
			{list.map((record, index) => (
				<TimeLine.Item key={`${record.createdDate}-${index}`} as="li">
					<Box className="stock-in-record-title">
						<Stack spacing={2} justifyContent="space-between" alignItems="center">
							<Typography variant="body2" className="mb-0">
								日期: {parseDate(record.createdDate, DateTimeStandard.DisplayDateBySlash)}
							</Typography>
							<Typography variant="body2" className="mb-0">
								擔當: {record.employeeName ?? "—"}
							</Typography>
						</Stack>
					</Box>

					<ActivityRecordCard status="default">
						{record.pdfUrl && <ActivityRecordCard.PdfAttachment pdfUrl={record.pdfUrl} />}
						<ActivityRecordCard.Content style={{ display: "flex", alignItems: "center" }}>
							<Box className="activity-record-card__main">
								<Typography variant="h6" className="title">
									{record.title}
								</Typography>
							</Box>
						</ActivityRecordCard.Content>
					</ActivityRecordCard>
				</TimeLine.Item>
			))}
		</TimeLine>
	);
};

ShipmentRecordList.propTypes = {
	records: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			pdfUrl: PropTypes.string,
			employeeName: PropTypes.string,
			createdDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
		}),
	),
	className: PropTypes.string,
};

export default ShipmentRecordList;
